import { getInvitationData } from "@/api/invitations";
import { UserSignUpForm } from "@/components/auth/user-sign-up-form";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";
import { useAppContext } from "@/providers/app-context";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import commonForgeLogo from "../assets/logo.svg";
import { PasswordRules } from "./password-reset";

export default function SignUpView() {
  const [searchParams, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [invitationData, setInvitationData] = React.useState<any>(undefined);
  const [invitationToken, setInvitationToken] = React.useState<string | null>(
    null,
  );

  const { setShowAbsoluteSpinner } = useAppContext();

  React.useEffect(() => {
    setShowAbsoluteSpinner(true);
    const init = async () => {
      if (searchParams.get("t")) {
        setInvitationToken(searchParams.get("t"));
        const invitation = (await getInvitationData(
          searchParams.get("t"),
        )) as any;
        if (!invitation.error) {
          setInvitationData(invitation);
        } else {
          navigate("/");
          toast({
            title: "Invalid invitation",
            description: "The invitation you are trying to use is not valid",
          });
        }
        setShowAbsoluteSpinner(false);
      } else {
        navigate("/");
      }
    };
    init();
    return () => {
      setShowAbsoluteSpinner(false);
    };
  }, []);

  if (!invitationData) return null;

  return (
    <>
      <div className="container relative grid h-[800px] min-h-screen flex-col items-center lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="lg:p-8">
          <div className="mx-auto flex w-full max-w-[500px] flex-col justify-center space-y-6 lg:w-[450px]">
            <div className="flex flex-col space-y-2">
              <h1 className="text-4xl font-light tracking-tight">
                Welcome to Common Forge!
              </h1>
              <p className="text-sm text-muted-foreground">
                You have been invited to join{" "}
                <span className="font-semibold">
                  {invitationData?.data?.organization}
                </span>
                . Please fill out the form below to get started.
              </p>
            </div>
            <PasswordRules />
            <UserSignUpForm invitationToken={invitationToken!} />
          </div>
        </div>
        <div className="relative hidden h-full flex-col p-10 dark:border-r lg:flex">
          <div className="absolute inset-0 bg-[url('/wind-power-plant-solar-pannels-low-angle.jpg')] bg-cover bg-center" />
          <div className="relative z-20 flex max-w-[610px] flex-col items-start">
            <img src={commonForgeLogo} className="mb-8 sm:w-[400px] xl:w-fit" />
            <div className="mb-4 text-2xl font-bold leading-snug [text-wrap:balance] xl:text-4xl xl:leading-snug">
              AI-Powered Project Review Automation
            </div>
            <Button asChild={true} variant={"outlineAlt"} className="">
              <a href="https://commonforge.com">Learn more...</a>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
